import AddressEdit from './AddressEdit/AddressEdit.store';
import Note from './Note/Note.store';
import QA from './QA/QA.store';
import Mobile from './Mobile/Mobile.store';
import MtEditor from './MtEditor/MtEditor.store';
import Question from './Question/Question.store';
import Setting from './Setting/Setting.store';
import ClassRestriction from './ClassRestriction/ClassRestriction.store';
import Bookmark from './Bookmark/Bookmark.store';
import Studentwork from './Studentwork/Studentwork.store';
import Survey from './Survey/Survey.store';

export default {
  namespaced: true,
  modules: {
    AddressEdit,
    Note,
    QA,
    Mobile,
    MtEditor,
    Question,
    Setting,
    ClassRestriction,
    Bookmark,
    Studentwork,
    Survey,
  },
};
